module.exports = __webpack_public_path__ + "static/media/papel_comestivel.af457fba.png";